import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Row, Col, ButtonGroup, Button } from 'reactstrap';
import { useParams, useNavigate, Link } from "react-router-dom";
import UserForm from '../UserForm/UserForm';
import PageTitle from '../../../components/PageTitle/PageTitle';
import Icon from '@mdi/react';
import { mdiAccountOutline, mdiAccountSchoolOutline } from '@mdi/js';

import { loadUser, updateUser, enableUser, disableUser } from '../../../redux/modules/users';

const UserEdit = props => {
    const { userId } = useParams();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadUser(userId));
    }, [ dispatch, userId ]);

    const { t }               = useTranslation();
    const { isLoading, user } = useSelector(state => state.users);
    const current_user        = useSelector(state => state.auth.user);

    if (!current_user || !user)
        return null;

    if (!current_user.isAdmin() && (current_user.id !== user.id))
        return navigate('/');

    const submit = values => {
        dispatch(updateUser(values));
    }

    const _toggleUserStatus = () => {
        if (user.is_active)
            dispatch(disableUser(user.id));
        else
            dispatch(enableUser(user.id));
    }

    const title = current_user.id === user.id ?
        <span>{t('users.update_my_profile')}</span>
        :
        <span>
            {t('users.user')}
            <small> | {t('users.update_user', {firstname: user.firstname, lastname: user.lastname})}</small>
        </span>

    const actions = (
        <div>
            {user &&
            <ButtonGroup>
                <Button tag={Link} to={ -1 } color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;
                    {t('common.back')}
                </Button>
                {current_user.id !== user.id &&
                    <Button disabled={isLoading} color={user.is_active ? 'danger' : 'success'} size="sm" onClick={ () => { _toggleUserStatus();  }}>
                        <i className={isLoading ? 'fa fa-spinner fa-spin' : user.is_active ? 'fa fa-pause' : 'fa fa-play'}></i>&nbsp;
                        {user.is_active ? t('users.disable') : t('users.enable')}
                    </Button>
                }
            </ButtonGroup>
            }
        </div>
    )

    return (
        <div className="UserEdit">
            <PageTitle icon={mdiAccountOutline} title={ title } actions={ actions } />

            {user &&
                <>
                    {user.student?.id && (
                    <Row className="align-items-center justify-content-start">
                        <Col xs="auto">
                            <ButtonGroup>
                                <Button tag={Link} color="info" to={`/users/edit/${user.id}`}>
                                    <Icon path={mdiAccountOutline} size={1} color="white" />&nbsp;
                                    {t('users.user_profile')}
                                </Button>
                                <Button tag={Link} color="dark" to={`/students/edit/${user.student.id}`}>
                                    <Icon path={mdiAccountSchoolOutline} size={1} color="white" />&nbsp;
                                    {t('users.student_profile')}
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                    )}
                    <UserForm userId={user.id} onSubmit={submit} />
                </>
            }
        </div>
    );
}

export default UserEdit;
